import dayjs from "dayjs";
import cloneDeep from "lodash.clonedeep";
import localForage from "localforage";
import { herokuapp_url } from "../app-config";
import { GET } from "./api";

export const _filterArray = (array, id, param) => {
	return array.filter(el => {
		return (
			(el[id]
				? typeof el[id] === "number"
					? el[id]
					: el[id].toLowerCase().replace(/ /g, "")
				: el[id]) !==
			(param
				? typeof param === "number"
					? param
					: param.toLowerCase().replace(/ /g, "")
				: param)
		);
	});
};

export const _isInViewPort = el => {
	let rect = el && el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight ||
				(document.documentElement &&
					document.documentElement.clientHeight)) /*or $(window).height() */ &&
		rect.right <=
			(window.innerWidth ||
				(document.documentElement &&
					document.documentElement.clientWidth)) /*or $(window).width() */
	);
};

export const _getUrlParameter = (queryParams, name) => {
	if (queryParams) {
		let query = queryParams.split("?")[1];
		let queryarr = query.split("&");

		for (let i = 0; i < queryarr.length; i++) {
			let pair = queryarr[i].split("=");
			if (pair[0] === name) return pair[1];
		}
	}

	return false;
};

export const _generateColor = () => {
	let letters = "0123456789ABCDEF".split("");
	let color = "#";
	for (let i = 0; i < 6; i++) {
		color += letters[Math.round(Math.random() * 10)];
	}

	return color;
};

export const _findArray = (array, id, param) => {
	return array.find(el => {
		return (
			(el[id]
				? typeof el[id] !== "string"
					? el[id]
					: el[id].toLowerCase().replace(/ /g, "")
				: el[id]) ===
			(param
				? typeof param !== "string"
					? param
					: param.toLowerCase().replace(/ /g, "")
				: param)
		);
	});
};

export const _isLightColor = (color, value) => {
	// Variables for red, green, blue values
	let r, g, b, hsp;
	// Check the format of the color, HEX or RGB?
	if (color.match(/^rgb/)) {
		// If HEX --> store the red, green, blue values in separate variables
		color = color.match(
			/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
		);
		r = color[1];
		g = color[2];
		b = color[3];
	} else {
		// If RGB --> Convert it to HEX
		color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));
		r = color >> 16;
		g = (color >> 8) & 255;
		b = color & 255;
	}
	// HSP equation
	hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
	// Using the HSP value, determine whether the color is light or dark
	if (!value) {
		value = 210;
	}
	return hsp > value;
};

export const _hex2rgba = (hex, alpha = 1) => {
	const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
	return `rgba(${r},${g},${b},${alpha})`;
};

export const _truncText = (text, limit) => {
	return text && limit
		? text.length > limit
			? `${text.substring(0, limit)}...`
			: text
		: text;
};

export const _uniqueArray = (array, param, type) => {
	if (type === "single") {
		return Array.from(new Set(array));
	} else {
		return Object.values(
			array.reduce((acc, cur) => Object.assign(acc, { [cur[param]]: cur }), {}),
		);
	}
};

export const _convertToSelectArray = (array, name, value) => {
	return array.forEach(el => {
		el.name = el[name] || "";
		el.label = el[name] || "";
		el.value = el[value] || "";
	});
};

export const _appendSelectAll = (array, text, value) => {
	array.length > 0 &&
		array.unshift({
			name: text || "All",
			value: value === undefined ? null : value,
		});
	return array;
};

export const _sortArray = (array, param, desc) => {
	return array.sort(compareValues(param, desc ? "desc" : "asc"));
};

export const _removeStringSpace = string => {
	return string ? string.replace(/ /g, "") : "";
};

export const _getNumberOrdinal = number => {
	let s = ["th", "st", "nd", "rd"];
	let v = number % 100;
	return number + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const _pluraliseString = (string, count) => {
	return count > 1 ? `${string}s` : string;
};

export const _validateNegativeNumber = (event, allowFloat) => {
	let key;
	if (event.type === "paste") {
		key = event.clipboardData.getData("text/plain");
	} else {
		key = event.keyCode || event.which;
		key = String.fromCharCode(key);
	}
	let regex = /^[-?\d+]+$/;

	if (!regex.test(key)) {
		if (allowFloat) {
			if (key !== ".") {
				event.returnValue = false;
				if (event.preventDefault) event.preventDefault();
			}
		} else {
			event.returnValue = false;
			if (event.preventDefault) event.preventDefault();
		}
	}
};

export const _validateNumber = (event, allowFloat, _value) => {
	let key;
	if (event.type === "paste") {
		key = event.clipboardData.getData("text/plain");
	} else {
		key = event.keyCode || event.which;
		key = String.fromCharCode(key);
	}
	let regex = /^\d+$/;

	if (!regex.test(key)) {
		if (allowFloat) {
			if (
				_value &&
				_value.length > 0 &&
				_value.indexOf(".") >= 0 &&
				key === "."
			) {
				event.returnValue = false;
				if (event.preventDefault) event.preventDefault();
			} else if (key !== ".") {
				event.returnValue = false;
				if (event.preventDefault) event.preventDefault();
			}
		} else {
			event.returnValue = false;
			if (event.preventDefault) event.preventDefault();
		}
	}
};

export const _validatePhoneNumber = (phoneNumber, mobileLength = 11) => {
	let maxLength, minLength;
	maxLength = mobileLength;
	minLength = mobileLength;
	if (phoneNumber) {
		if (/^\d+$/.test(phoneNumber)) {
			phoneNumber = phoneNumber.toString();
			if (Number(phoneNumber.substring(0, 1)) === 0) {
				if (
					phoneNumber.length !== 0 &&
					(phoneNumber.length > maxLength || phoneNumber.length < minLength)
				) {
					return `Phone numbers should have a ${
						phoneNumber.length > maxLength
							? `maximum of ${maxLength}`
							: `minimum of ${maxLength}`
					} numbers`;
				} else {
					if (phoneNumber.length > 1 && phoneNumber.charAt(1) === "0") {
						return `Invalid phone number`;
					} else {
						return "";
					}
				}
			} else {
				return `Phone numbers should start with 0`;
			}
		} else {
			return `Invalid phone number`;
		}
	} else {
		return "";
	}
};

export const _getLocationDistances = (lat1, lon1, lat2, lon2, format) => {
	if (lat1 && lat2 && lon1 && lon2) {
		lat1 = Number(lat1);
		lon1 = Number(lon1);
		lat2 = Number(lat2);
		lon2 = Number(lon2);
		let p = 0.017453292519943295; // Math.PI / 180
		let c = Math.cos;
		let a =
			0.5 -
			c((lat2 - lat1) * p) / 2 +
			(c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
		let distance = 12742 * Math.asin(Math.sqrt(a));
		if (format === "m") {
			return distance * 1000;
		}
		return distance > 1
			? parseFloat(Number.parseFloat(distance).toFixed(1)) + " km"
			: parseFloat(Number.parseFloat(distance * 1000).toFixed(1)) + " m";
	} else {
		return "";
	}
};

export const _capitalizeText = text => {
	if (typeof text !== "string") {
		return text;
	}
	return text
		? text
				.toLowerCase()
				.split(" ")
				.map(word => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" ")
		: "";
};

export const _convertToUpperCase = string => {
	return string ? string.toUpperCase() : "";
};

export const _compressImage = (file, size, name) => {
	return new Promise((resolve, reject) => {
		try {
			let updatedFile;
			const img = new Image();
			const imgUrl = window.URL.createObjectURL(file);
			img.onload = () => {
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d");
				const width = size || 250;
				const scaleFactor = width / img.width;
				canvas.width = width;
				canvas.height = img.height * scaleFactor;
				ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
				ctx.canvas.toBlob(
					blob => {
						updatedFile = new File([blob], name || "imgupload.jpg", {
							type: "image/jpeg",
							lastModified: Date.now(),
						});
						resolve(updatedFile);
					},
					"image/jpeg",
					1,
				);
			};
			img.onerror = error => {
				resolve({ error });
			};
			img.src = imgUrl;
		} catch (error) {
			console.log(error);
		}
	});
};

export const _isSameDate = (firstDate, secondDate) => {
	return firstDate &&
		secondDate &&
		dayjs(firstDate).isValid() &&
		dayjs(secondDate).isValid()
		? firstDate.getFullYear() === secondDate.getFullYear() &&
				firstDate.getMonth() === secondDate.getMonth() &&
				firstDate.getDate() === secondDate.getDate()
		: false;
};
export const _formatDate = (date, format = "YYYY-MM-DD") => {
	return date && dayjs(date).isValid() ? dayjs(date).format(format) : "";
};
export const _formatDate2 = date => {
	return date && dayjs(date).isValid() ? dayjs(date).format("DD-MM-YYYY") : "";
};

export const _formatTime = (date, flag) => {
	if (flag === 1)
		return date && dayjs(date).isValid() ? dayjs(date).format("HH:mm:ss") : "";
	else return date && dayjs(date).isValid() ? dayjs(date).format("HH:mm") : "";
};

export const _getTimeDifference = (
	firstDate,
	secondDate,
	unit,
	roundUp = false,
) => {
	if (
		firstDate &&
		secondDate &&
		unit &&
		dayjs(firstDate).isValid() &&
		dayjs(secondDate).isValid()
	) {
		firstDate = dayjs(firstDate);
		secondDate = dayjs(secondDate);
		return firstDate.diff(secondDate, unit, roundUp);
	} else {
		return 0;
	}
};

export const _cloneArray = array => {
	if (array) {
		return cloneDeep(array);
	}
};

export const _combineDateAndTime = (
	date,
	time,
	showYear,
	timeOnly,
	resetDate,
) => {
	try {
		if (!date) {
			date = new Date();
			date.setHours(0, 0, 0, 0);
		} else if (date && resetDate) {
			date = new Date(date);
			date.setHours(0, 0, 0, 0);
		}

		if (date && time) {
			if (time.includes(":")) {
				if (timeOnly) {
					return dayjs(
						dayjs(date).add(
							Number(time.split(":")[0]) * 60 + Number(time.split(":")[1]),
							"minutes",
						),
					).format("h:mm a");
				} else {
					return (
						(showYear
							? dayjs(date).format("MMM D, YYYY")
							: dayjs(date).format("MMM D")) +
						". " +
						dayjs(
							dayjs(date).add(
								Number(time.split(":")[0]) * 60 + Number(time.split(":")[1]),
								"minutes",
							),
						).format("h:mm a")
					);
				}
			}
		} else if (date) {
			return showYear
				? dayjs(date).format("MMM D, YYYY")
				: dayjs(date).format("MMM D");
		} else return "";
	} catch (error) {
		return "";
	}
};

function compareValues(key, order = "asc") {
	return function innerSort(a, b) {
		if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
			return 0;
		}
		if (a[key] === "" || a[key] === null || a[key] === undefined) {
			return 1;
		}
		if (b[key] === "" || b[key] === null || b[key] === undefined) {
			return -1;
		}

		const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
		const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

		let comparison = 0;
		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return order === "desc" ? comparison * -1 : comparison;
	};
}

export const _isPushNotificationsSupported = () => {
	return (
		"Notification" in window &&
		navigator.serviceWorker &&
		"PushManager" in window &&
		"showNotification" in ServiceWorkerRegistration.prototype
	);
};

export const _insertInString = (
	stringToSearch,
	stringToFind,
	stringToInsert,
) => {
	if (stringToSearch && stringToFind && stringToInsert) {
		const index = stringToSearch.lastIndexOf(stringToFind);
		if (index < 0) {
			return stringToSearch;
		} else {
			return (
				stringToSearch.substring(0, index) +
				stringToInsert +
				stringToSearch.substring(index)
			);
		}
	} else {
		return stringToSearch;
	}
};

export const _isViewingInApp = () => {
	if (window.matchMedia) {
		return window.matchMedia("(display-mode: standalone)").matches;
	} else return false;
};

export const _getIsoDateString = currentDate => {
	const date = currentDate || new Date();
	return new Date(
		date.getTime() - date.getTimezoneOffset() * 60000,
	).toISOString();
};

export const _cloneObject = object => {
	if (object) {
		return cloneDeep(object);
	}
};
export const _fetchFile = async url => {
	if (!navigator.onLine) {
		return new File([""], `image-${Math.random()}.png`);
	}
	//const shouldUseProxy = !window.location.hostname.includes(".omnibiz.com");
	const shouldUseProxy = true;
	let proxyUrls = [herokuapp_url];
	let proxyIndex = 0;
	const imageUrl = shouldUseProxy ? `${proxyUrls[proxyIndex]}${url}` : url;

	let response = await fetch(imageUrl);
	if (response.ok) {
		let blob = await response.blob();
		let file = new File([blob], `image-${Math.random()}.png`);
		return file;
	} else {
		if (proxyIndex < proxyUrls.length && shouldUseProxy) {
			proxyIndex = proxyIndex + 1;
			_fetchFile(url);
		} else {
			return new File([""], `image-${Math.random()}.png`);
		}
	}
};

export const _uniqueArrayCount = (array, key) => {
	let count = new Set();
	for (let el of array) {
		count.add(el[key]);
	}

	return count.size;
};

export const _groupArray = (array, field) => {
	return array.reduce(function (h, obj) {
		h[obj[field]] = (h[obj[field]] || []).concat(obj);
		return h;
	}, {});
};

export const _getFromLocalStorage = field => {
	try {
		let fieldData = localStorage.getItem(field);
		let fieldDataValue = {};
		switch (field) {
			case "countryData":
				fieldDataValue = fieldData
					? JSON.parse(fieldData)
					: {
							ISDCode: "234",
							countryId: 1,
							countryname: "Nigeria",
							currency: "NG",
							currencyCode: "NGN",
							mobileLength: 11,
							TimeZone: "W. Central Africa Standard Time",
							UTC: "UTC +1",
							stateLabel: "State",
							lgaLabel: "Lga",
							cityLabel: "City",
							lang: "English",
					  };
				break;
			case "cityAndStatesData":
				let countryData = localStorage.getItem("countryData");
				fieldDataValue = fieldData
					? JSON.parse(fieldData)
					: {
							city: [
								{
									text: `Select ${countryData.lgaLabel}`,
									value: "",
									state: "",
									stateId: 0,
									name: `Select ${countryData.lgaLabel}`,
								},
							],
							states: [
								{
									text: `Select ${countryData.stateLabel}`,
									value: "",
									isdefault: 0,
									name: `Select ${countryData.stateLabel}`,
								},
							],
							stateCityCoordinates: [
								{
									latitude: "0",
									longitude: "0",
									state: `Select ${countryData.stateLabel}`,
									lga: `Select ${countryData.stateLabel}`,
								},
							],
					  };
				break;
			default:
				fieldDataValue = JSON.parse(fieldData);
		}
		return fieldDataValue;
	} catch (error) {
		return "";
	}
};

export const _formatCurrency = (amount, flag) => {
	let countryData = _getFromLocalStorage("countryData");
	if (amount || amount === 0) {
		let currencyAmount = new Intl.NumberFormat(`en-${countryData.currency}`, {
			style: "currency",
			currency: countryData.currencyCode,
			minimumFractionDigits: 0,
		}).format(Number(amount));
		if (flag === 1 && amount && Number(amount) > 999999) {
			try {
				let currencySybmol = currencyAmount.split("")[0];
				let currencyAmountInNumber = Number(
					currencyAmount.substring(1).replace(/,/g, ""),
				);
				if (currencyAmountInNumber >= 1000000000) {
					currencyAmountInNumber =
						(currencyAmountInNumber / 1000000000)
							.toFixed(1)
							.replace(/\.0$/, "") + "B";
				}
				if (currencyAmountInNumber >= 1000000) {
					currencyAmountInNumber =
						(currencyAmountInNumber / 1000000).toFixed(1).replace(/\.0$/, "") +
						"M";
				}
				currencyAmount = `${currencySybmol}${currencyAmountInNumber}`;
			} catch (error) {}
		} else if (flag === 2) {
			currencyAmount = currencyAmount.substring(0, currencyAmount.length - 1);
		} else if (flag === 3) {
			currencyAmount = currencyAmount.replace(" ", "");
			currencyAmount = currencyAmount.substring(0, currencyAmount.length - 1);
		}

		return currencyAmount;
	}
};

export const _isValidUrl = string => {
	if (!string.includes("http")) {
		string = "http://" + string;
	}
	if (string.includes("www.")) {
		string = string.replace("www.", "");
	}
	const pattern = new RegExp(
		"^(https?:\\/\\/)?" + // protocol
			"((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
			"((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
			"(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
			"(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
			"(\\#[-a-z\\d_]*)?$",
		"i",
	); // fragment locator
	return !!pattern.test(string);
};

export const _validateAccountNumber = accountNumber => {
	let maxLength = 10,
		minLength = 10;
	if (accountNumber) {
		if (/^\d+$/.test(accountNumber)) {
			accountNumber = accountNumber.toString();
			if (
				accountNumber.length !== 0 &&
				(accountNumber.length > maxLength || accountNumber.length < minLength)
			) {
				return `Account numbers should have a ${
					accountNumber.length > maxLength
						? `maximum of ${maxLength}`
						: `minimum of ${maxLength}`
				} numbers`;
			} else {
				return "";
			}
		} else {
			return `Invalid account number`;
		}
	} else {
		return "";
	}
};

export const _validateRequiredField = (string, fieldName) => {
	if (!string || !string.trim()) {
		return fieldName ? `${fieldName} is required` : `This field is required`;
	} else {
		return "";
	}
};

export const _delayAsyncFunction = duration => {
	return new Promise(resolve => setTimeout(resolve, duration || 0));
};

export const _isSameDay = (firstDay, secondDay) => {
	try {
		return (
			dayjs(dayjs(firstDay).format("MMM D, YYYY")).toDate().valueOf() ===
			dayjs(dayjs(secondDay).format("MMM D, YYYY")).toDate().valueOf()
		);
	} catch (error) {}
};

export const _sumArrayFields = (array, field) => {
	try {
		let sum = 0;
		array.forEach(el => {
			if (el[field]) {
				sum = sum + Number(el[field]);
			}
		});
		return sum;
	} catch (error) {
		return 0;
	}
};

export const _isOverflown = element => {
	try {
		if (element)
			return (
				element.scrollHeight > element.clientHeight ||
				element.scrollWidth > element.clientWidth
			);
		else return false;
	} catch (error) {
		return false;
	}
};

export const _printElement = (elementId, timeout, cb) => {
	if (!elementId || !document.getElementById(elementId)) {
		return;
	}
	toggleMobilePrintClass();
	//create iframe
	let iframe = document.createElement("iframe");
	iframe.style.width = "0px";
	iframe.style.height = "0px";
	iframe.style.position = "absolute";
	document.body.appendChild(iframe);

	let content = document.getElementById(elementId);
	let printEl = iframe.contentWindow;

	//get parent styles
	let parentStyleSheets = document.styleSheets;
	//console.log(getComputedStyle(document), parentStyleSheets);
	let cssString = "";
	for (let i = 0, count = parentStyleSheets.length; i < count; ++i) {
		try {
			if (parentStyleSheets[i].cssRules) {
				let cssRules = parentStyleSheets[i].cssRules;
				for (let j = 0, countJ = cssRules.length; j < countJ; ++j)
					cssString += cssRules[j].cssText;
			} else cssString += parentStyleSheets[i].cssText; // IE8 and earlier
		} catch (error) {}
	}
	let style = document.createElement("style");
	style.type = "text/css";

	try {
		style.innerHTML = cssString;
	} catch (e) {
		style.styleSheet.cssText = cssString; // IE8 and earlier
	}

	printEl.document.open();
	printEl.document.write(content.innerHTML);

	iframe.contentDocument.head.appendChild(style);

	printEl.document.close();
	printEl.focus();
	setTimeout(() => {
		printEl.print();
		toggleMobilePrintClass();
		cb && cb();
	}, timeout || 2000);
};

function toggleMobilePrintClass() {
	const printContentClasses = [
		".order-preview-payment",
		".bo-modal-body-header",
		".package-list",
	];
	if (window.screen.width < 767) {
		printContentClasses.forEach(el => {
			const classElement = document.querySelector(el);
			if (classElement) {
				classElement.classList.toggle("is-mobile-print");
			}
		});
	}
}

export const _deepStringCompare = (firstString, secondString) => {
	if (!firstString || !secondString) {
		return false;
	}
	firstString = firstString.replace(/[^0-9a-z]/gi, "");
	secondString = secondString.replace(/[^0-9a-z]/gi, "");
	return firstString.toLowerCase() === secondString.toLowerCase();
};

export const _disablePullDownRefresh = () => {
	try {
		document.querySelector("body").style.overscrollBehaviorY = "contain";
	} catch (error) {
		console.log(error);
	}
};

export const _enablePullDownRefresh = () => {
	try {
		document.querySelector("body").style.overscrollBehaviorY = "auto";
	} catch (error) {}
};

export const _supportsWebRtc = () => {
	return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
};

export const _isNullOrEmptyArray = arr => {
	return !Array.isArray(arr) || !arr.length;
};

export const _validateName = (name, maxLength) => {
	if (!maxLength) {
		maxLength = 50;
	}
	if (name) {
		name = name.toString().trim();
		if (!name.length) {
			return "Add name";
		}
		if (
			name.length === 1 ||
			["undefined", "null"].includes(name.toLowerCase())
		) {
			return "Invalid name";
		}
		if (name.length > maxLength) {
			return "Name is too long";
		}
		return "";
	} else {
		return "";
	}
};

export const _formatDistance = distance => {
	if (!distance) {
		return 0;
	}
	distance = Number(Number(distance).toFixed(2));
	return distance;
};

export function _memoize(func) {
	const cache = {};
	const slice = Array.prototype.slice;
	return function () {
		var args = slice.call(arguments);
		if (args in cache) {
			return cache[args];
		}
		return (cache[args] = func.apply(this, args));
	};
}

export function _getFormData(formData, data, previousKey, arrayField) {
	if (data instanceof Object) {
		Object.keys(data).forEach(key => {
			const value = data[key];
			if (
				value instanceof Object &&
				!Array.isArray(value) &&
				!(value instanceof File)
			) {
				return _getFormData(formData, value, key, arrayField);
			}
			if (previousKey) {
				key = `${arrayField}[${previousKey}][${key}]`;
			}
			if (Array.isArray(value)) {
				value.forEach(val => {
					formData.append(`${key}[]`, val);
				});
			} else {
				formData.append(key, value);
			}
		});
	}
}

export const db = {
	get: async function (key) {
		try {
			const value = await localForage.getItem(key);
			return value;
		} catch (error) {
			return null;
		}
	},
	post: async function (key, value) {
		try {
			await localForage.setItem(key, value);
		} catch (error) {}
	},
	delete: async function (key) {
		try {
			if (key) {
				localForage.removeItem(key);
			}
		} catch (error) {}
	},
};

export const _setCurrencyInputValue = amount => {
	if (!amount) {
		return "";
	}
	return amount
		.toString()
		.replace(/\D/g, "")
		.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const _readableText = text => {
	return text.replace(/,([^,]*)$/, " and$1");
};

export const _imageProxyUrl = () => {
	//const shouldUseProxy = !window.location.hostname.includes(".omnibiz.com");
	const shouldUseProxy = true;
	if (shouldUseProxy) {
		return herokuapp_url;
	}
	return "";
};

export const storage = {
	get: function (key) {
		try {
			const value = JSON.parse(localStorage.getItem(key));
			return value;
		} catch (error) {
			return null;
		}
	},
	set: function (key, value) {
		try {
			localStorage.setItem(key, JSON.stringify(value));
		} catch (error) {}
	},
	delete: function (key) {
		try {
			if (key) {
				const keys = key.split(",");
				for (const el of keys) {
					localStorage.removeItem(el);
				}
			}
		} catch (error) {}
	},
};

export const _staleWhileValidate = async (requestUrl, storageKey, apiKey) => {
	try {
		const storageValue = await db.get(storageKey);
		if (storageValue) {
			updateCache();
			return storageValue;
		} else {
			const result = await updateCache();
			return result;
		}

		async function updateCache() {
			const result = await GET(requestUrl);
			if (!result.error && result[apiKey]) {
				db.post(storageKey, result[apiKey]);
				return result[apiKey];
			}
			return null;
		}
	} catch (error) {
		return null;
	}
};
export const _truncateStringOfCommas = (text, number) => {
	if (text && typeof text === "string") {
		const arrOfStrings = text.split(",");
		const reducedArr = arrOfStrings.slice(0, number);
		const newText = reducedArr.join(reducedArr.length === 2 ? " and " : ", ");
		const remainingLength = arrOfStrings.length - reducedArr.length;
		return arrOfStrings.length > 2
			? `${newText} ${remainingLength > 0 ? `& ${remainingLength} more` : ""}`
			: newText;
	}
	return "";
};

export const _mergeArray = (arr1, arr2, duplicate = false) => {
	if (duplicate) {
		return [...new Set(arr1.concat(arr2))];
	}
	return arr1.concat(arr2);
};

export const idempotencyKey = () => {
	var newTime = new Date();
	return newTime.toJSON().split(":").slice(0, 2).join("").replace(/\D+/g, "");
};

export const _shuffleArray = arr => {
	return arr.sort(() => 0.5 - Math.random());
};

export const _deepObjectFilter = (obj, filter) => {
	for (let key in obj) {
		const val = obj[key];

		if (typeof val === "object") {
			_deepObjectFilter(val, filter);
		} else {
			if (filter(val) === false) {
				delete obj[key];
			}
		}
		if (JSON.stringify(val) === "{}") {
			delete obj[key];
		}
	}
};
